import { render, staticRenderFns } from "./HeaderControlsAuditLog.vue?vue&type=template&id=61580222&"
import script from "./HeaderControlsAuditLog.vue?vue&type=script&lang=js&"
export * from "./HeaderControlsAuditLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61580222')) {
      api.createRecord('61580222', component.options)
    } else {
      api.reload('61580222', component.options)
    }
    module.hot.accept("./HeaderControlsAuditLog.vue?vue&type=template&id=61580222&", function () {
      api.rerender('61580222', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/HeaderControlsAuditLog.vue"
export default component.exports